import { useState, useEffect } from "react";

export default function SearchableSelect({ fetchApi, value, onChange, isInValid = false }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [options, setOptions] = useState([]);

  // gọi BE mỗi khi search thay đổi
  useEffect(() => {
    let timeout = setTimeout(async () => {
      const res = await fetchApi(search);
      setOptions(res || []);
    }, 300); // debounce nhẹ

    return () => clearTimeout(timeout);
  }, [search]);

  return (
    <div className="position-relative" style={{ width: "100%" }}>
      <input
        className={`form-control ${isInValid ? "is-invalid" : ""}`}
        placeholder="Search..."
        value={search}
        onFocus={() => setOpen(true)}
        onChange={(e) => setSearch(e.target.value)}
      />

      {open && (
        <div
          className="border rounded bg-white position-absolute w-100 mt-1 shadow-sm"
          style={{ maxHeight: "200px", overflowY: "auto", zIndex: 1000 }}
        >
          {options.map(opt => (
            <div
              key={opt.value}
              className="p-2 hover-bg"
              style={{ cursor: "pointer" }}
              onClick={() => {
                onChange(opt);
                setSearch(opt.label);
                setOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}

          {options.length === 0 && (
            <div className="p-2 text-muted small">No results</div>
          )}
        </div>
      )}
    </div>
  );
}
